import { useStoreMap } from 'effector-react'
import {
  rentalContractModel,
  useRentalContractStatus,
} from '~/entities/RentalContract'
import {
  CURRENCY,
  rentalContractStatusEnumLabels,
} from '~/shared/config/constants'
import { formatDays } from '~/shared/lib/utils'
import { ChevronRightIcon } from '~/shared/ui/icons'
import { myPalette } from '~/shared/ui/theme'
import { WorkScheduleButton } from '../WorkScheduleButton'
import {
  Chip,
  TopBlockWrapper,
  Typography,
  Block,
  BlockTitle,
  BlockDescription,
  BlockTariff,
  BottomBlockWrapper,
  FullWidthBlockWrapper,
} from './styled'

export function Descriptions() {
  const rentalContract = useStoreMap(
    rentalContractModel.$rentalContract,
    (rentalContract) => rentalContract?.getAttributes(),
  )

  const status = rentalContract?.status
    ? rentalContractStatusEnumLabels[rentalContract.status]
    : null

  const { isSuspended } = useRentalContractStatus()

  return (
    <>
      <TopBlockWrapper>
        <div>
          <Typography
            style={{
              paddingBottom: '8px',
              fontSize: '18px',
              fontWeight: '500',
            }}
            data-testid='main-car-model'
          >
            {rentalContract?.carBrandTitle} {rentalContract?.carModelTitle}
          </Typography>
          <Chip data-testid='main-car-plate-number'>
            {rentalContract?.carPlateNumber}
          </Chip>
        </div>
        <BlockTariff>
          <Typography
            style={{ fontSize: '16px' }}
            data-testid='main-car-tariff'
          >
            Тариф &quot;{rentalContract?.carCategoryName}&quot;
          </Typography>
          <div style={{ marginTop: '2px' }}>
            <ChevronRightIcon color={myPalette.white.main} />
          </div>
        </BlockTariff>
      </TopBlockWrapper>

      <BottomBlockWrapper>
        <WorkScheduleButton />
        <Block
          style={{
            ...(isSuspended ? { background: myPalette.coral.main } : {}),
          }}
        >
          {isSuspended ? (
            <Typography>
              Договор{' '}
              <Typography
                style={{ textTransform: 'lowercase', display: 'inline' }}
              >
                {status}
              </Typography>
            </Typography>
          ) : (
            <>
              <BlockTitle>Стоимость аренды</BlockTitle>
              <BlockDescription data-testid='main-car-rent-per-day'>
                {rentalContract?.rentPerDay &&
                  Number(rentalContract?.rentPerDay).toLocaleString()}
                {CURRENCY} / сутки
              </BlockDescription>
            </>
          )}
        </Block>
      </BottomBlockWrapper>
      {rentalContract?.promotion && (
        <FullWidthBlockWrapper>
          <Block>
            <BlockTitle>Для данного договора действует акция</BlockTitle>
            <BlockDescription>
              {rentalContract?.promotion?.discount_amount
                ? `-${rentalContract?.promotion?.discount_amount} ${CURRENCY}`
                : `-${rentalContract?.promotion?.discount_percent}%`}{' '}
              на {formatDays(rentalContract?.promotion?.duration_days ?? 0)}
            </BlockDescription>
          </Block>
        </FullWidthBlockWrapper>
      )}
    </>
  )
}
